<template>
  <section class="jumbotron">
    <div class="jumbotron__wrapper">
      <article class="jumbotron__bubble">
        <h1 class="jumbotron__h1">Välkommen {{ user.firstName }},</h1>
        <h2 class="jumbotron__h2">till din digitala pensionsrådgivare.</h2>
      </article>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Jumbotron',
  computed: {
    ...mapGetters(['user']),
  }
}
</script>

<style lang="scss">
.jumbotron {
  background-color: $mediumGreen;
  height: 510px;
  background-image: url('../../assets/img/jumbotron-kid.png');
  background-size: cover;
  background-position: center;

  &__wrapper {
    display: grid;
    grid-template-columns: 100%;
    height: 100%;
    max-width: $maxWidth;
    margin: 0 auto;

    @include breakpoints(small) {
      grid-template-columns: 50% 50%;
    }
  }

  &__bubble {
    // Grid
    grid-column: 1;
    align-self: center;
    justify-self: center;
    // Flexbox
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    // Other
    height: 274px;
    width: 274px;
    border-radius: 50%;
    background-color: $lightYellow;
    text-align: center;
  }
  &__h1 {
    font-size: 28px;
  }
  &__h2 {
    font-family: "Roboto", sans-serif; // Overrides Roboto-Medium for h2
    font-size: 22px;
    font-weight: lighter;
  }
}
</style>